import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMPTY = { name: "", company: "", email: "", message: "" };

export default function ContactSection({ t }) {
  const [form, setForm] = useState(EMPTY);
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success(t.contact.success);
      setForm(EMPTY);
    } catch {
      toast.error(t.contact.error);
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contact" className="py-24 lg:py-32 bg-[#F4F5F7]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-2 gap-16">
        <div>
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-[#5A6B7C] mb-6" data-testid="contact-overline">
            {t.contact.overline}
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight text-[#0B1B3D] mb-6" data-testid="contact-title">
            {t.contact.title}
          </h2>
          <p className="text-base md:text-lg text-[#5A6B7C]" data-testid="contact-text">
            {t.contact.text}
          </p>
        </div>
        <form onSubmit={submit} data-testid="contact-form" className="bg-white border border-[#E2E8F0] p-8 lg:p-10 space-y-6">
          <div className="grid sm:grid-cols-2 gap-6">
            <div className="space-y-2">
              <Label htmlFor="contact-name">{t.contact.form.name}</Label>
              <Input id="contact-name" data-testid="contact-name-input" required value={form.name} onChange={set("name")} className="rounded-none" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="contact-company">{t.contact.form.company}</Label>
              <Input id="contact-company" data-testid="contact-company-input" value={form.company} onChange={set("company")} className="rounded-none" />
            </div>
          </div>
          <div className="space-y-2">
            <Label htmlFor="contact-email">{t.contact.form.email}</Label>
            <Input id="contact-email" type="email" data-testid="contact-email-input" required value={form.email} onChange={set("email")} className="rounded-none" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="contact-message">{t.contact.form.message}</Label>
            <Textarea id="contact-message" data-testid="contact-message-input" required rows={5} value={form.message} onChange={set("message")} className="rounded-none" />
          </div>
          <button
            type="submit"
            disabled={sending}
            data-testid="contact-submit-button"
            className="w-full bg-[#0B1B3D] text-white font-medium px-6 py-4 hover:bg-[#2A2D34] transition-colors disabled:opacity-60"
          >
            {sending ? t.contact.form.sending : t.contact.form.submit}
          </button>
        </form>
      </div>
    </section>
  );
}
